import { render, staticRenderFns } from "./comp_DynamicPageItems.vue?vue&type=template&id=7a224b40&scoped=true&"
import script from "./comp_DynamicPageItems.vue?vue&type=script&lang=js&"
export * from "./comp_DynamicPageItems.vue?vue&type=script&lang=js&"
import style0 from "./comp_DynamicPageItems.vue?vue&type=style&index=0&id=7a224b40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a224b40",
  null
  
)

export default component.exports